import languagesJSON from "@/assets/supportedLanguages.json";
import { Button } from "@/shadcn/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/shadcn/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcn/components/ui/popover";
import { getUserLanguage, setUserLanguage } from "@/utils/utils.util";
import { ScrollArea } from "@radix-ui/react-scroll-area";
import i18next from "i18next";
import { Check, ChevronsUpDown } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

type LanguageChangerProps = {
  // TODO: add props here
};

const LanguageChanger: React.FC<LanguageChangerProps> = (props) => {
  const { t } = useTranslation();
  const languages = languagesJSON.languages;

  const [userLang, setUserLang] = React.useState<string>(
    getUserLanguage().toLowerCase()
  );

  console.log("User Language: " + userLang);
  console.log("Supported Languages: " + languages);

  function handleLanguageChange(isoCode: string) {
    console.log("Language changed to: " + isoCode);
    i18next.changeLanguage(isoCode);
    setUserLang(isoCode);
    setUserLanguage(isoCode);
  }

  return (
    <Popover modal>
      <PopoverTrigger asChild>
        <Button
          id="language-changer"
          variant="outline"
          className="w-full justify-between"
        >
          {
            // find the language name from the languages array using the userLang
            languages.find(
              (language) =>
                language.iso_code.toLowerCase() === userLang.toLowerCase()
            )?.name ?? t("Select Language")
          }

          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0">
        <Command>
          <CommandInput placeholder={t("Search language...")} />
          <CommandList>
            <ScrollArea className="max-h-[200px]">
              <CommandEmpty>No language found.</CommandEmpty>
              <CommandGroup>
                {languages.map((language) => (
                  <CommandItem
                    key={language.iso_code}
                    onSelect={() =>
                      handleLanguageChange(language.iso_code.toLowerCase())
                    }
                  >
                    <Check
                      className={`mr-2 h-4 w-4 ${
                        userLang.toLowerCase() ===
                        language.iso_code.toLowerCase()
                          ? "opacity-100"
                          : "opacity-0"
                      }`}
                    />
                    {language.native_name}
                  </CommandItem>
                ))}
              </CommandGroup>
            </ScrollArea>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default LanguageChanger;
